import { useTranslation } from 'react-i18next';

import { apiErrorContent } from '@/components/atoms/ApiErrorMessage';
import { ToastError } from '@/components/molecules/ToastTemplate/ToastTemplate';
import { useEndImpersonation } from '@/domain/auth';

/**
 * Ends an impersonation from the banner and reloads the app as the user's own account. The
 * banner fires it and moves on, so a failure is told in a toast rather than rejected.
 */
export function useSwitchBackToOwnAccount(): (event: {
    preventDefault: () => void;
}) => Promise<void> {
    const { t } = useTranslation();
    const endImpersonation = useEndImpersonation(() => {
        window.location.replace('/');
    });

    return async (event) => {
        event.preventDefault();
        try {
            await endImpersonation();
        } catch (error: unknown) {
            ToastError(
                apiErrorContent(error, t('impersonation.banner.switchBackFailed')),
                'switch-back-error'
            );
        }
    };
}
